import { createSelector } from "reselect";
import { SET_LOADING } from "./mask.actions";

const INITIAL_STATE = {
  active: false,
};

export default function loader_mask(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case SET_LOADING: {
      return {
        active: action.loading,
        msg: action.msg,
      };
    }
    default: {
      return state;
    }
  }
}

export const selectLoaderMaskState = (state) => state.loader_mask;

export const getLoaderMaskStatus = createSelector(
  selectLoaderMaskState,
  (state) => state.active
);

export const getLoaderMaskMessage = createSelector(
  selectLoaderMaskState,
  (state) => state.msg
);
